/* MM / Avis — assets/mm-reviews.js
   Le carrousel est un Splide monté par SplideManager (mm_components.js) :
   drag, molette, flèches externes et leur état disabled sont natifs. En
   desktop (≥ 1280px) toutes les cartes tiennent dans la scène (CSS) : Splide
   reste immobile. Ce script ne garde que les deux gestes propres à la
   section :

   - l'ENTRÉE desktop : les cartes arrivent portées par un ressort élastique
     et un peu de désordre (en mobile, le reveal générique du kit) ;
   - l'INERTIE au survol : la carte est poussée par l'élan du curseur.

   Idempotent (garde data-mm-reviews-ready) : les previews ré-exécutent les
   scripts. */
(function () {
  'use strict';

  var SEUIL = window.MEDIUM_DESKTOP_BREAKPOINT || 1280;

  function init(root) {
    if (root.dataset.mmReviewsReady === 'true') return;
    root.dataset.mmReviewsReady = 'true';

    var rail = root.querySelector('[data-reviews-rail]');
    if (!rail) return;

    function estDeck() { return window.innerWidth >= SEUIL; }
    function cellules() { return [].slice.call(rail.children); }

    /* ---- Le geste d'ENTRÉE --------------------------------------------------
       Les cartes ENTRENT portées par le ressort élastique et un peu de
       désordre. Chaque carte part d'une distance et d'un retard légèrement
       différents : parfaitement synchronisées, quatre cartes se liraient comme
       un seul bloc qui glisse, pas comme un paquet de cartes qu'on rebat. */
    var DUREE_ENTREE = 1100;   /* le ressort a besoin de temps pour osciller */
    var PAS_CASCADE = 60;      /* décalage d'une carte à l'autre */
    var DISTANCE = 100;        /* en % de la largeur de carte */
    var DESORDRE = 1;          /* 0 = cascade réglée au cordeau */

    function alea(min, max) { return min + Math.random() * (max - min); }

    function entrer(cartes, sens) {
      cartes.forEach(function (cell, i) {
        /* la PREMIÈRE carte part sans retard, le désordre ne commence qu'après */
        var retard = i * PAS_CASCADE + (i === 0 ? 0 : DESORDRE * alea(0, 110));
        var distance = DISTANCE * (1 + DESORDRE * alea(-0.28, 0.28));
        if (cell._mmAnim) cell._mmAnim.cancel();
        cell._mmAnim = MmMotion.elasticFrom(cell, {
          x: sens * distance, unit: '%', rotate: sens * -3,
          duration: DUREE_ENTREE, delay: retard, fade: true, fadeStart: 0.03
        });
        /* l'opacité posée à la main pour éviter le flash d'attente est rendue
           au CSS dès que l'animation a pris la main */
        cell._mmAnim.onfinish = function () { cell.style.removeProperty('opacity'); };
      });
    }

    /* Entrée de la scène : en desktop, le geste ressort + désordre plutôt
       que le reveal générique du kit (gardé en mobile). Toutes les cartes
       sont visibles en desktop : elles entrent toutes. */
    function entreeInitiale() {
      if (!estDeck() || !window.IntersectionObserver || !window.MmMotion) return;
      var cs = cellules();
      cs.forEach(function (c) {
        c.removeAttribute('data-mm-reveal');
        c.style.opacity = '0';
      });
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (en) { return en.isIntersecting; })) return;
        io.disconnect();
        entrer(cs, 1);
      }, { threshold: 0.25 });
      io.observe(rail);
    }

    /* ---- Inertie au survol -------------------------------------------------
       La carte est POUSSÉE par l'élan du curseur : elle part dans le sens du
       mouvement et pivote selon le COUPLE au point d'entrée (entrer par un
       coin fait tourner, entrer par le centre pousse tout droit), puis un
       ressort-amorti la ramène. C'est le geste du prototype de Killian
       (GSAP InertiaPlugin) — le plugin n'étant pas vendorisé dans le kit
       (licence Club GreenSock payante), la physique est réécrite ici à la
       main : un système masse-ressort intégré à chaque frame, la VITESSE du
       curseur devenant directement la vitesse initiale de la carte. Contraire
       à elasticFrom (courbe échantillonnée, durée fixe quelle que soit
       l'entrée), un geste rapide donne ici un retour plus long et plus ample,
       un geste lent un retour bref — la durée émerge du calcul.

       La cible est la CARTE — ni la cellule, qui porte l'entrée, ni
       l'enveloppe, qui porte l'inclinaison de repos : trois étages, trois
       transforms, aucun qui écrase les autres. */
    function borne(v, max) { return Math.max(-max, Math.min(max, v)); }

    /* Ressort-amorti (spring-damper) sur 1 degré de liberté : part d'une
       VITESSE initiale (position 0), revient à 0. Paramétré en fréquence
       propre / ratio d'amortissement (wn/zeta) plutôt qu'en raideur/friction
       brutes — plus lisible pour viser un dépassement (overshoot) léger
       façon InertiaPlugin + ease élastique, sans osciller indéfiniment.
       set(valeur) reçoit la position courante à chaque frame. */
    var WN = 6;              /* fréquence propre — plus haut = retour plus rapide, amplitude moindre */
    var ZETA = 0.55;         /* ratio d'amortissement — <1 = dépassement, proche de 1 = pas d'oscillation */
    var RAIDEUR = WN * WN;
    var AMORTISSEMENT = 2 * ZETA * WN;
    var SEUIL_REPOS = 0.01;  /* sous ce seuil (position ET vitesse), on arrête */

    function ressort(position, vitesse, set, fin) {
      var raf = null;
      var dernier = performance.now();
      function frame(maintenant) {
        var dt = Math.min((maintenant - dernier) / 1000, 1 / 30);
        dernier = maintenant;
        var force = -RAIDEUR * position - AMORTISSEMENT * vitesse;
        vitesse += force * dt;
        position += vitesse * dt;
        if (Math.abs(position) < SEUIL_REPOS && Math.abs(vitesse) < SEUIL_REPOS) {
          raf = null;
          if (fin) fin();
          return;
        }
        set(position);
        raf = window.requestAnimationFrame(frame);
      }
      raf = window.requestAnimationFrame(frame);
      return { cancel: function () { if (raf) window.cancelAnimationFrame(raf); } };
    }

    function inertieAuSurvol() {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var vx = 0, vy = 0, px = 0, py = 0, tick = null;
      root.addEventListener('mousemove', function (e) {
        /* une mesure par frame : mousemove tire bien plus souvent que l'écran
           ne se rafraîchit, et deux événements du même frame donnent un delta
           de 0 qui écraserait la vélocité réelle */
        if (tick) return;
        tick = window.requestAnimationFrame(function () {
          vx = e.clientX - px; vy = e.clientY - py;
          px = e.clientX; py = e.clientY;
          tick = null;
        });
      }, { passive: true });

      /* On écoute sur la CELLULE, immobile au repos, et on anime la CARTE.
         Écouter sur la carte elle-même la faisait fuir sous le curseur : elle
         sortait de sa propre zone de survol, ce qui déclenchait un mouseleave
         puis un nouveau mouseenter, donc une projection en boucle — le glitch
         signalé par Killian. Le prototype fait pareil : la zone de détection
         (data-momentum-hover-element) ne bouge jamais, seule la cible bouge. */
      cellules().forEach(function (cell) {
        var carte = cell.querySelector('.mm-rcard');
        if (!carte) return;
        cell.addEventListener('mouseenter', function (e) {
          var r = carte.getBoundingClientRect();
          var ox = e.clientX - (r.left + r.width / 2);
          var oy = e.clientY - (r.top + r.height / 2);
          var couple = ox * vy - oy * vx;
          var levier = Math.hypot(ox, oy) || 1;

          if (carte._mmInertieX) carte._mmInertieX.cancel();
          if (carte._mmInertieY) carte._mmInertieY.cancel();
          if (carte._mmInertieR) carte._mmInertieR.cancel();

          var etat = { x: 0, y: 0, r: 0 };
          function peindreCarte() {
            carte.style.transform = 'translate(' + etat.x + 'px, ' + etat.y + 'px) rotate(' + etat.r + 'deg)';
          }
          /* Les 3 ressorts (x, y, rotation) tournent indépendamment mais
             peignent le MÊME transform : retirer le style inline dès qu'un
             axe se pose écraserait les deux autres encore en mouvement — donc
             on ne nettoie qu'une fois les trois arrêtés. */
          var enCours = 3;
          function unAxeFini() {
            enCours--;
            if (enCours === 0) carte.style.removeProperty('transform');
          }
          /* vx/vy sont un delta par frame (~16ms) : converti en unités/seconde
             pour que la RAIDEUR/AMORTISSEMENT du ressort (calibrés en px/s)
             produisent une amplitude cohérente quelle que soit la fréquence
             d'échantillonnage réelle de la souris. */
          carte._mmInertieX = ressort(0, borne(vx * 60, 900), function (v) { etat.x = v; peindreCarte(); }, unAxeFini);
          carte._mmInertieY = ressort(0, borne(vy * 60, 900), function (v) { etat.y = v; peindreCarte(); }, unAxeFini);
          carte._mmInertieR = ressort(0, borne(couple / levier * 12, 220), function (v) { etat.r = v; peindreCarte(); }, unAxeFini);
        });
      });
    }

    inertieAuSurvol();
    entreeInitiale();
  }

  function setup(scope) {
    (scope || document).querySelectorAll('.mm-reviews').forEach(init);
  }

  window.MmReviews = { setup: setup };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setup(); });
  } else {
    setup();
  }
})();
